"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dirigibles = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
class Dirigibles extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.DIRIGIBLES,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.VENUS],
            cost: 11,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                cardNumber: '222',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 Floater to ANY card', (eb) => {
                        eb.empty().startAction.floaters(1).asterix();
                    }).br;
                    b.effect('When playing a Venus tag, Floaters here may be used as payment, and are worth 3M€ each.', (eb) => {
                        eb.venus(1).played.startEffect.floaters(1).equals().megacredits(3);
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const floaterCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER);
        if (floaterCards.length === 1) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select card to add 1 floater', 'Add floater', floaterCards, (foundCards) => {
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
    }
}
exports.Dirigibles = Dirigibles;
//# sourceMappingURL=Dirigibles.js.map